<script>
import Icon from './icon';
import EventBus from '../instances/event-bus';
import scrolling from '../../modules/freeze-scroll';

const FOCUSABLE_ELEMENTS = ['a[href]', 'area[href]', 'input:not([disabled])', 'select:not([disabled])', 'textarea:not([disabled])', 'button:not([disabled])', 'iframe', 'object', 'embed', '[contenteditable]', '[tabindex]:not([tabindex^="-"])'];
const TAB_KEY = 9;
const ESCAPE_KEY = 27;

export default {
  components: {
    Icon
  },
  data () {
    return {
      focusedBeforeModal: null
    }
  },
  props: {
    dismissable: true,
    active: false,
    title: ''
  },
  computed: {
    loggedIn() { return this.$store.state.loggedIn; }
  },
  updated () {
    if (!!this.active) {
      this.focusedBeforeModal = document.activeElement;
      scrolling.disable();
      document.body.addEventListener('focus', this._maintainFocus, true);
      document.addEventListener('keydown', this._bindKeypress);
      this._maintainFocus = this._maintainFocus.bind(this);
      this._bindKeypress = this._bindKeypress.bind(this);
      this.setFocusToFirstItem();
    }
    else {
      scrolling.enable();
      document.body.removeEventListener('focus', this._maintainFocus, true);
      document.removeEventListener('keydown', this._bindKeypress);
      if (this.focusedBeforeModal) {
        this.focusedBeforeModal.focus();
      }
    }
  },
  methods: {
    _bindKeypress(event) {
      // If the dialog is shown and the ESCAPE key is being pressed, prevent any
      // further effects from the ESCAPE key and hide the dialog
      if (event.which === ESCAPE_KEY) {
        event.preventDefault();
        EventBus.$emit('closeModal');
      }

      // If the dialog is shown and the TAB key is being pressed, make sure the
      // focus stays trapped within the dialog element
      if (this.active && event.which === TAB_KEY) {
        this.trapTabKey(event);
      }
    },
    _maintainFocus(event) {
      // If the dialog is shown and the focus is not within the dialog element,
      // move it back to its first focusable child
      if (this.active && !this.$el.contains(event.target)) {
        this.setFocusToFirstItem();
      }
    },
    setFocusToFirstItem () {
      let focusableChildren = this.getFocusableChildren();

      if (focusableChildren.length) {
        focusableChildren[0].focus();
      }
    },
    getFocusableChildren() {
      return this.$$(FOCUSABLE_ELEMENTS.join(','), this.$el).filter( (child) => {
        return !!(child.offsetWidth || child.offsetHeight || child.getClientRects().length);
      });
    },
    trapTabKey (event) {
      let focusableChildren = this.getFocusableChildren();
      let focusedItemIndex = focusableChildren.indexOf(document.activeElement);

      // If the SHIFT key is being pressed while tabbing (moving backwards) and
      // the currently focused item is the first one, move the focus to the last
      // focusable item from the dialog element
      if (event.shiftKey && focusedItemIndex === 0) {
        focusableChildren[focusableChildren.length - 1].focus();
        event.preventDefault();
      // If the SHIFT key is not being pressed (moving forwards) and the currently
      // focused item is the last one, move the focus to the first focusable item
      // from the dialog element
      } else if (!event.shiftKey && focusedItemIndex === focusableChildren.length - 1) {
        focusableChildren[0].focus();
        event.preventDefault();
      }
    },
    close() {
      EventBus.$emit('closeModal');
    },
    handleClick(event) {
      let target = event.target;
      if (!target.closest('.Modal-content')) {
        this.close();
      }
    },
    $$(selector, context) {
      return this.toArray((context || document).querySelectorAll(selector));
    },
    toArray (collection) {
      return Array.prototype.slice.call(collection);
    }
  }
}
</script>

<template lang="html">
  <transition name="v-fade">
    <div v-if="active" class="Modal" @click="handleClick">
      <div class="Modal-content">
        <button v-if="dismissable === true" class="Modal-close" @click="close">
          <icon icon="close"></icon>
          <span class="u-screenreader">close</span>
        </button>
        <p v-if="!!title" class="Modal-title">{{ title }}</p>
        <slot></slot>
      </div>
    </div>
  </transition>
</template>



// WEBPACK FOOTER //
// modal.vue?581beec1